import { all, call, put, take } from 'redux-saga/effects';
import { LOAD_LOGO, LOAD_PRIVACY_WORDING, LOAD_TERM_WORDING } from '../type';
import {
  loadPrivacyWordingSuccessAction,
  loadPrivacyWordingErrorAction,
  loadTermWordingSuccessAction,
  loadTermWordingErrorAction,
} from '../action';

import { utilService } from 'services';

function* loadTermWordingAction() {
  while (1) {
    try {
      const action = yield take(LOAD_TERM_WORDING);
      const termData = yield call(utilService.loadCompanyAsset, action.payload);
      yield put(loadTermWordingSuccessAction(termData));
    } catch (err) {
      yield put(loadTermWordingErrorAction(err));
    }
  }
}

function* loadPrivacyWordingAction() {
  while (1) {
    try {
      const action = yield take(LOAD_PRIVACY_WORDING);
      const privacyData = yield call(
        utilService.loadCompanyAsset,
        action.payload,
      );
      yield put(loadPrivacyWordingSuccessAction(privacyData));
    } catch (err) {
      yield put(loadPrivacyWordingErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([loadPrivacyWordingAction(), loadTermWordingAction()]);
}
